import { type FC } from "react";
import { KeyboardKey } from "@/components/keyboard/KeyboardKey";
import { cn } from "@/components/podkit/lib/cn";
import { type PlainAgentExecution } from "@/queries/agent-queries";
import { agentExecutionLoading } from "@/utils/agent-executions";
import { useAgentExecutionActions } from "@/hooks/use-agent-execution-actions";

export const StopButton: FC<{ agentExecution: PlainAgentExecution }> = ({ agentExecution }) => {
    const { handleStopAgentExecution } = useAgentExecutionActions(agentExecution);

    const isButtonDisabled = !agentExecution || !agentExecutionLoading(agentExecution);

    const handleClick = async (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        await handleStopAgentExecution();
    };

    return (
        <div
            className={cn(
                "flex h-6 cursor-pointer items-center gap-2 rounded text-sm",
                isButtonDisabled ? "cursor-not-allowed opacity-50" : "text-content-secondary",
            )}
            onClick={isButtonDisabled ? undefined : handleClick}
            data-tracking-id="stop-agent-execution-todo-list"
        >
            <span
                className={
                    agentExecution && agentExecutionLoading(agentExecution)
                        ? "text-content-primary"
                        : "text-content-secondary"
                }
            >
                Stop
            </span>
            <KeyboardKey
                className={cn(
                    "bg-content-secondary/20 dark:bg-content-secondary/40",
                    agentExecution && agentExecutionLoading(agentExecution)
                        ? "text-content-primary"
                        : "text-content-secondary",
                )}
            >
                Esc
            </KeyboardKey>
        </div>
    );
};
